<div class="modal-header border-0 px-lg-5 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Ajout d'un véhicule</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>

<div class="modal-body">
	<div class="row px-lg-5 px-2">
		<div class="">
			<div class="row">
				<span class="theme-main-color fs-4 col">Informations</span>
			</div>
			<div class="row my-2">
				<form id="formAjout" [formGroup]="formAjout" (ngSubmit)="onSubmit()">
					<div class="row mt-4">
						<div class="col-4">
							<label for="name" class="form-label theme-main-color fw-bold"
								>Nom du véhicule</label
							>
							<input
								autocomplete="off"
								required
								type="text"
								class="form-control"
								id="name"
								name="name"
								formControlName="name"
								[ngClass]="{
									'is-invalid': name.invalid && (name.dirty || name.touched),
									'is-valid': name.dirty && name.valid
								}"
							/>
							<div
								*ngIf="name.invalid && (name.dirty || name.touched)"
								class="invalid-feedback"
							>
								<span *ngIf="name.errors?.required">Un nom est requis</span>
								<span *ngIf="name.errors?.maxlength"
									>Le nom ne doit pas dépasser
									{{ MAX_NAME_CHAR }} caractères</span
								>
								<span *ngIf="name.errors?.pattern"
									>Le format du nom n'est pas correct</span
								>
							</div>
						</div>
						<div class="col-4">
							<label for="model" class="form-label theme-main-color fw-bold"
								>Modèle</label
							>
							<input
								autocomplete="off"
								type="text"
								class="form-control"
								id="model"
								name="model"
								formControlName="model"
								[ngClass]="{
									'is-invalid': model.invalid && (model.dirty || model.touched),
									'is-valid': model.dirty && model.valid
								}"
							/>
							<div
								*ngIf="model.invalid && (model.dirty || model.touched)"
								class="invalid-feedback"
							>
								<span *ngIf="model.errors?.required">Un modèle est requis</span>
								<span *ngIf="model.errors?.maxlength"
									>Le modèle ne doit pas dépasser
									{{ MAX_NAME_CHAR }} caractères</span
								>
								<span *ngIf="name.errors?.pattern"
									>Le format du modèle n'est pas correct</span
								>
							</div>
						</div>
					</div>

					<div class="row my-4">
						<div class="col-4">
							<label for="rented" class="form-label theme-main-color fw-bold"
								>En location</label
							>
							<div class="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									id="rented"
									formControlName="rented"
								/>
							</div>
						</div>
						<div class="col-4">
							<label for="gps" class="form-label theme-main-color fw-bold"
								>GPS intégré</label
							>
							<div class="form-check">
								<input
									class="form-check-input"
									type="checkbox"
									id="gps"
									formControlName="gps"
								/>
							</div>
						</div>
						<div class="col-4">
							<label for="status" class="form-label theme-main-color fw-bold"
								>Status</label
							>
							<select
								required
								class="form-select"
								name="status"
								id="status"
								formControlName="status"
							>
								<option
									*ngFor="let status of vehiculeStatus | keyvalue"
									[ngValue]="status.key"
								>
									{{ status.value }}
								</option>
							</select>
						</div>
					</div>

					<div class="row my-4">
						<div class="col-6">
							<label
								for="travelledDistance"
								class="form-label theme-main-color fw-bold"
								>Distance parcourue</label
							>
							<div class="input-group">
								<input
									class="form-control"
									type="number"
									formControlName="travelledDistance"
									[ngClass]="{
										'is-invalid':
											travelledDistance.invalid &&
											(travelledDistance.dirty || travelledDistance.touched),
										'is-valid':
											travelledDistance.dirty && travelledDistance.valid
									}"
								/>
								<span class="input-group-text" id="">km</span>
							</div>
						</div>
						<div class="col-6">
							<label
								for="mileageCost"
								class="form-label theme-main-color fw-bold"
								>Coût kilométrique</label
							>
							<div class="input-group">
								<input
									class="form-control"
									type="number"
									formControlName="mileageCost"
									[ngClass]="{
										'is-invalid':
											mileageCost.invalid &&
											(mileageCost.dirty || mileageCost.touched),
										'is-valid': mileageCost.dirty && mileageCost.valid
									}"
								/>
								<span class="input-group-text" id="">€</span>
							</div>
						</div>
					</div>

					<div class="row my-5">
						<div class="d-flex justify-content-end">
							<button
								class="btn theme-main-color-button mx-3 px-3"
								type="button"
								(click)="bsModalRef.hide()"
							>
								Retour
							</button>
							<button
								[disabled]="!formAjout.valid || isValidateButtonClicked"
								class="btn theme-green-button"
								type="submit"
								form="formAjout"
							>
								<i class="bi bi-save-fill px-1" aria-hidden="true"></i
								>Sauvegarder
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
